import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { mat_acumuladas } from "../../services/api";

const Matriculas_acumuladas = (props) => {

    const [data2, setData2] = useState([]);
    const [dataR, setDataR] = useState([]);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', '', '', 'Seropédica', 'Barra', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha', 'Freguesia', 'Recreio']

    const fetchData = async () => {
        try {
            const response = await mat_acumuladas();
            setData2(response);
        } catch (error) {
            console.error(error);
        }
    };

    console.log("data2", data2);

    useEffect(() => {
        fetchData();
    }, []);

    let cumulativo = [];
    let acumulador = { alunos20: 0, alunos21: 0, alunos22: 0, alunos23: 0, alunos24: 0, alunos25: 0, alunos26: 0 };

    // Iterar sobre os dados para somar cumulativamente
    data2.forEach((item, index) => {
        acumulador.alunos20 += parseInt(item.alunos20);
        acumulador.alunos21 += parseInt(item.alunos21);
        acumulador.alunos22 += parseInt(item.alunos22);
        acumulador.alunos23 += parseInt(item.alunos23);
        acumulador.alunos24 += parseInt(item.alunos24);
        acumulador.alunos25 += parseInt(item.alunos25);
        acumulador.alunos26 += parseInt(item.alunos26);
        cumulativo.push(
            [
                item.dia,

                acumulador.alunos22,
                acumulador.alunos23,
                acumulador.alunos24,
                acumulador.alunos25,
                acumulador.alunos26
            ]
        );
    });

    // cumulativo.unshift(["Dia", "2020", "2021", "2022", "2023", "2024", "2025"]);
    cumulativo.unshift(["Dia", "2022", "2023", "2024", "2025", "2026"]);

    const options = {
        chart: {
            title: "Total de Matriculas",
            subtitle: "Todos os alunos",
        },
    };


    console.log("acumulado", cumulativo);
    return (
        <div className="acumula">
            <center>
                <Chart
                    chartType="Line"
                    version="current"
                    width="90%"
                    height="450px"
                    data={cumulativo}
                    options={options}
                />

            </center>

        </div>
    );


};
export default Matriculas_acumuladas;